import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'shared-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: false
})
export class SpinnerComponent {

  @Input() color = "green";

  constructor() { }

}
